import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  id: "EnrolmentReviewModal"
}
const _hoisted_2 = { class: "EnrolmentReviewModalHeaderBlock" }
const _hoisted_3 = { class: "EnrolmentReviewModalContentBlock" }
const _hoisted_4 = { class: "ContentConfirmation MassReviewDisclaimerContentConfirmation" }
const _hoisted_5 = { class: "MassReviewDisclaimerCheckbox" }
const _hoisted_6 = { class: "MassReviewDisclaimerLabel" }
const _hoisted_7 = { class: "EnrolmentReviewModalHeaderBlock" }
const _hoisted_8 = { class: "EnrolmentReviewModalContentBlock" }
const _hoisted_9 = { class: "EnrolmentReviewModalHeaderBlock" }
const _hoisted_10 = { class: "EnrolmentReviewModalContentBlock" }
const _hoisted_11 = {
  key: 0,
  class: "WarningContainer ChallengeBackNote"
}
const _hoisted_12 = { class: "WarningMessageNotEndor" }
const _hoisted_13 = { class: "WarningMessageIntro" }
const _hoisted_14 = { class: "ChallengeBackNoteQuote" }
const _hoisted_15 = { class: "ContentConfirmation" }
const _hoisted_16 = { class: "RadioButtonLabel" }
const _hoisted_17 = ["checked", "onChange"]
const _hoisted_18 = { class: "EnrolmentReviewModalContentBlock" }
const _hoisted_19 = { class: "ContentConfirmation" }
const _hoisted_20 = { class: "ContentConfirmationUpper" }
const _hoisted_21 = { class: "RadioButtonLabel" }
const _hoisted_22 = ["disabled", "checked", "onChange"]
const _hoisted_23 = {
  key: 0,
  class: "WarningContainer ReviewWarningContainer"
}
const _hoisted_24 = { class: "EnrolmentReviewModalContentBlock" }
const _hoisted_25 = { class: "ContentConfirmation" }
const _hoisted_26 = { class: "ModalConfirmationTitle" }
const _hoisted_27 = { class: "RadioButtonLabel" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "EnrolmentReviewModalHeaderBlock" }
const _hoisted_30 = { class: "EnrolmentReviewModalContentBlock" }
const _hoisted_31 = { class: "ContentConfirmation" }
const _hoisted_32 = { class: "ModalConfirmationTitle" }
const _hoisted_33 = {
  id: "IntakeForm",
  class: "FgForm",
  name: "EditForm",
  novalidate: "",
  autocomplete: "off"
}
const _hoisted_34 = {
  key: 0,
  class: "FgElementWrapper"
}
const _hoisted_35 = {
  key: 1,
  class: "ElementWrapper"
}
const _hoisted_36 = {
  key: 2,
  class: "WarningContainer ReviewWarningContainer"
}
const _hoisted_37 = {
  key: 3,
  class: "ElementWrapper"
}
const _hoisted_38 = {
  key: 4,
  class: "FgElementWrapper"
}
const _hoisted_39 = { class: "FgMessageContainer" }
const _hoisted_40 = { class: "FgMessage ErrorMessage" }
const _hoisted_41 = {
  key: 5,
  class: "ElementWrapper"
}
const _hoisted_42 = { class: "MessageContainer" }
const _hoisted_43 = { class: "Message ErrorMessage" }
const _hoisted_44 = {
  key: 6,
  class: "FgElementWrapper"
}
const _hoisted_45 = { class: "FgMessageContainer" }
const _hoisted_46 = { class: "FgMessage ErrorMessage" }
const _hoisted_47 = {
  key: 7,
  class: "ElementWrapper"
}
const _hoisted_48 = {
  key: 8,
  class: "FgElementWrapper"
}
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = {
  key: 0,
  class: "OptionalLabel"
}
const _hoisted_51 = { class: "MessageContainer" }
const _hoisted_52 = { class: "Message ErrorMessage" }
const _hoisted_53 = { class: "EnrolmentReviewModalHeaderBlock" }
const _hoisted_54 = { class: "EnrolmentReviewModalContentBlock" }
const _hoisted_55 = { class: "ContentConfirmation" }
const _hoisted_56 = { class: "ContentConfirmationUpper" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "AttentionRequiredMessageWrapper" }
const _hoisted_62 = { class: "AttentionRequiredMessage" }
const _hoisted_63 = {
  key: 0,
  class: "MassReviewTransitionErrorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnrolmentReviewPopupButtons = _resolveComponent("EnrolmentReviewPopupButtons")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.massReviewDisclaimerIsActive)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, "Reviewing " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.amountOfEnrolmentsDisplayText), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("p", null, " Depending on the options you select we may ask you to provide additional information for these enrolments (for example, tuition fee). ", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _createElementVNode("input", {
                    class: "MassReviewDisclaimerInput",
                    type: "checkbox",
                    checked: false,
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enrolmentReview.setMassReviewDisclaimerShowStatus($event)))
                  }, null, 32 /* NEED_HYDRATION */),
                  _cache[6] || (_cache[6] = _createTextVNode(" Don't show this message again ", -1 /* CACHED */))
                ])
              ])
            ]),
            _createVNode(_component_EnrolmentReviewPopupButtons, { enrolmentReview: _ctx.enrolmentReview }, null, 8 /* PROPS */, ["enrolmentReview"])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.tuitionFeeSkipReviewIsActive)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", null, "Preconfirming " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.amountOfEnrolmentsDisplayText), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ContentConfirmation" }, [
                _createElementVNode("div", { class: "ContentConfirmationUpper" }, [
                  _createElementVNode("p", null, "All selected enrolments already have a tuition fee specified. Would you like to override these values?")
                ])
              ], -1 /* CACHED */)),
              _createVNode(_component_EnrolmentReviewPopupButtons, { enrolmentReview: _ctx.enrolmentReview }, null, 8 /* PROPS */, ["enrolmentReview"])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_ctx.triggerSelectionReviewIsActive)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", null, "Reviewing " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.amountOfEnrolmentsDisplayText), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.enrolmentHasNote && !_ctx.isInternalReview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, "Why to revisit " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.theseEnrolmentsDisplayText) + ":", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_14, "\"" + _toDisplayString(_ctx.confirmationChallengeNote) + "\"", 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_15, [
                  _cache[10] || (_cache[10] = _createElementVNode("h6", { class: "ModalConfirmationTitle" }, "Select enrolment status", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enrolmentReview.availableTriggers, (trigger, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: trigger.name
                    }, [
                      _createElementVNode("label", _hoisted_16, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "transition",
                          checked: trigger.equals(_ctx.enrolmentReview.selectedTrigger),
                          onChange: ($event: any) => (_ctx.enrolmentReview.changeTrigger(trigger)),
                          class: "RadioButton"
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_17),
                        _createTextVNode(" " + _toDisplayString(trigger.name), 1 /* TEXT */)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createVNode(_component_EnrolmentReviewPopupButtons, { enrolmentReview: _ctx.enrolmentReview }, null, 8 /* PROPS */, ["enrolmentReview"])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.successFeeSelectionReviewIsActive)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "EnrolmentReviewModalHeaderBlock" }, [
                  _createElementVNode("h3", null, "Commission (success fee)")
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[11] || (_cache[11] = _createElementVNode("h6", { class: "ModalConfirmationTitle" }, "Select category", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enrolmentReview.availableSuccessFeeOptions, (successFeeOption, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: successFeeOption.value
                        }, [
                          _createElementVNode("label", _hoisted_21, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "successFee",
                              disabled: successFeeOption.disabled,
                              checked: successFeeOption.equals(_ctx.enrolmentReview.selectedSuccessFeeOption),
                              onChange: ($event: any) => (_ctx.enrolmentReview.changeSelectedSuccessFeeOption(successFeeOption)),
                              class: "RadioButton"
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_22),
                            _createTextVNode(" " + _toDisplayString(successFeeOption.name), 1 /* TEXT */)
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    (_ctx.isInternalReview && _ctx.enrolmentReview.nationalitySuccessFeeOptionIsDisabled())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */),
                          _createTextVNode(" Reduced commission is not available, because some selected enrolments do not have a nationality specified. ", -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createVNode(_component_EnrolmentReviewPopupButtons, { enrolmentReview: _ctx.enrolmentReview }, null, 8 /* PROPS */, ["enrolmentReview"])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : (_ctx.additionalNoPayReasonSelectionReviewIsActive)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "EnrolmentReviewModalHeaderBlock" }, [
                    _createElementVNode("h3", null, "Commission (success fee)")
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h6", _hoisted_26, " Specify why " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.theseStudentsDisplayText) + " is not qualified for commission payment ", 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enrolmentReview.availableNoPayReasons, (noPayReason, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: noPayReason.name
                        }, [
                          _createElementVNode("label", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              name: "successFee",
                              value: noPayReason,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.noPayReasons) = $event)),
                              class: "RadioButton"
                            }, null, 8 /* PROPS */, _hoisted_28), [
                              [_vModelCheckbox, _ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.noPayReasons]
                            ]),
                            _createTextVNode(" " + _toDisplayString(noPayReason.name), 1 /* TEXT */)
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createVNode(_component_EnrolmentReviewPopupButtons, { enrolmentReview: _ctx.enrolmentReview }, null, 8 /* PROPS */, ["enrolmentReview"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : (_ctx.triggerPayloadReviewFormIsActive)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.triggerPayloadPopupConfiguration.title), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("h6", _hoisted_32, _toDisplayString(_ctx.triggerPayloadPopupConfiguration.label), 1 /* TEXT */),
                        _createElementVNode("form", _hoisted_33, [
                          (_ctx.enrolmentReview.requiresTuitionFee())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "tuitionFee",
                                  class: _normalizeClass(["FgInput FormInput js-Input", {
									HasValue: _ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.tuitionFee !== undefined,
									HasError: !_ctx.enrolmentReview.validationResult.isTuitionFeeValid
								}]),
                                  type: "number",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.tuitionFee) = $event))
                                }, null, 2 /* CLASS */), [
                                  [_vModelText, _ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.tuitionFee]
                                ]),
                                _cache[15] || (_cache[15] = _createElementVNode("label", {
                                  class: "FgLabel",
                                  for: "tuitionFee"
                                }, "First year tuition fee", -1 /* CACHED */)),
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "FgMessageContainer" }, [
                                  _createElementVNode("span", { class: "FgMessage ErrorMessage" }, "Please specify the tuition fee")
                                ], -1 /* CACHED */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.requiresTuitionFee())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createVNode(_component_MultiSelect, {
                                  ref: "currencyDropdown",
                                  label: "Currency",
                                  placeholder: "Nothing selected",
                                  options: _ctx.currenciesAsOptions,
                                  searchable: true,
                                  entity: "currency",
                                  valid: _ctx.enrolmentReview.validationResult.isTuitionFeeCurrencyValid,
                                  validationLabel: "Please select a currency",
                                  onUpdated: _ctx.setTuitionFeeCurrency
                                }, null, 8 /* PROPS */, ["options", "valid", "onUpdated"]),
                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "MessageContainer" }, [
                                  _createElementVNode("span", { class: "Message ErrorMessage" }, "Please specify the currency")
                                ], -1 /* CACHED */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.requiresTuitionFee() && _ctx.isInternalReview)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */),
                                _createTextVNode(" This will override the tuition fee for all selected enrolments. ", -1 /* CACHED */)
                              ]))]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.requiresNationality())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createVNode(_component_MultiSelect, {
                                  ref: "nationalityDropdown",
                                  label: "Student nationality",
                                  placeholder: "Nothing selected",
                                  options: _ctx.countriesAsOptions,
                                  searchable: true,
                                  entity: "country",
                                  valid: _ctx.enrolmentReview.validationResult.isNationalityValid,
                                  validationLabel: "Please select a country",
                                  onUpdated: _ctx.setStudentNationality
                                }, null, 8 /* PROPS */, ["options", "valid", "onUpdated"])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.requiresIntakeInformation())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "intakeYear",
                                  class: _normalizeClass(["FgInput FormInput js-Input", {
									HasValue: _ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.intakeYear !== undefined,
									HasError: !_ctx.enrolmentReview.validationResult.isIntakeYearValid
								}]),
                                  type: "number",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.intakeYear) = $event))
                                }, null, 2 /* CLASS */), [
                                  [_vModelText, _ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.intakeYear]
                                ]),
                                _cache[19] || (_cache[19] = _createElementVNode("label", {
                                  class: "FgLabel",
                                  for: "intakeYear"
                                }, "Intake year", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("span", _hoisted_40, "Please enter the year the " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.studentsDisplayText) + " starts studying", 1 /* TEXT */)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.requiresIntakeInformation())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createVNode(_component_MultiSelect, {
                                  ref: "monthDropdown",
                                  label: "Intake month",
                                  placeholder: "Nothing selected",
                                  options: _ctx.monthsAsOptions,
                                  searchable: true,
                                  entity: "month",
                                  valid: _ctx.enrolmentReview.validationResult.isIntakeMonthValid,
                                  validationLabel: "Please select a month",
                                  onUpdated: _ctx.setIntakeMonth
                                }, null, 8 /* PROPS */, ["options", "valid", "onUpdated"]),
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("span", _hoisted_43, "Please enter the month the " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.studentsDisplayText) + " starts studying", 1 /* TEXT */)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.requiresProgrammeInformation())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "programmeName",
                                  class: _normalizeClass(["FgInput FormInput js-Input", {
									HasValue: _ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.programmeName !== undefined,
									HasError: !_ctx.enrolmentReview.validationResult.isProgrammeNameValid
								}]),
                                  type: "text",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.programmeName) = $event))
                                }, null, 2 /* CLASS */), [
                                  [_vModelText, _ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.programmeName]
                                ]),
                                _cache[20] || (_cache[20] = _createElementVNode("label", {
                                  class: "FgLabel",
                                  for: "programmeName"
                                }, "Programme name", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("span", _hoisted_46, "Please specify the programme of the " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.studentsDisplayText), 1 /* TEXT */)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.requiresProgrammeInformation())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createVNode(_component_MultiSelect, {
                                  ref: "levelDropdown",
                                  label: "Degree",
                                  placeholder: "Nothing selected",
                                  options: _ctx.programmeLevelsAsOptions,
                                  searchable: true,
                                  entity: "programme level",
                                  valid: _ctx.enrolmentReview.validationResult.isProgrammeLevelValid,
                                  validationLabel: "Please select a programme level",
                                  onUpdated: _ctx.setProgrammeLevel
                                }, null, 8 /* PROPS */, ["options", "valid", "onUpdated"]),
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "MessageContainer" }, [
                                  _createElementVNode("span", { class: "Message ErrorMessage" }, "Please specify the programme degree")
                                ], -1 /* CACHED */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_ctx.enrolmentReview.includeNote())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: _normalizeClass(["Textarea Note", { HasError: !_ctx.enrolmentReview.validationResult.isNoteValid }]),
                                  placeholder: _ctx.triggerPayloadPopupConfiguration ? _ctx.triggerPayloadPopupConfiguration.notesPlaceholder : '',
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.enrolmentReview.selectedTriggerPayload.note) = $event))
                                }, null, 10 /* CLASS, PROPS */, _hoisted_49), [
                                  [_vModelText, _ctx.enrolmentReview.selectedTriggerPayload.note]
                                ]),
                                (_ctx.enrolmentReview.isNoteOptional())
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, " Optional "))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.triggerPayloadPopupConfiguration ? _ctx.triggerPayloadPopupConfiguration.notesErrorText : ''), 1 /* TEXT */)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createVNode(_component_EnrolmentReviewPopupButtons, { enrolmentReview: _ctx.enrolmentReview }, null, 8 /* PROPS */, ["enrolmentReview"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (_ctx.massReviewConfirmationIsActive)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("h3", null, "Reviewing " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.amountOfEnrolmentsDisplayText), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            (_ctx.enrolmentReview.selectedTrigger)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "ModalConfirmationTitle" }, "Enrolment status", -1 /* CACHED */)),
                                  (_ctx.selectedTriggerIsOtherSpecifiedStatus)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, "Other, custom status"))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(_ctx.enrolmentReview.selectedTrigger.name), 1 /* TEXT */))
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true),
                            (
								_ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.successFee ||
								_ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.noPayReasons.length
							)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[23] || (_cache[23] = _createElementVNode("h6", { class: "ModalConfirmationTitle" }, "Success Fee", -1 /* CACHED */)),
                                  (_ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.successFee)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(_ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.successFee.name), 1 /* TEXT */))
                                    : (_ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.noPayReasons.length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_60, " No commission, " + _toDisplayString(_ctx.enrolmentReview.selectedTriggerPayload.successFeeInformation.noPayReasons[0].name), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.intakeMonth)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _cache[24] || (_cache[24] = _createElementVNode("h6", { class: "ModalConfirmationTitle" }, "Intake date", -1 /* CACHED */)),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.intakeMonth.name) + " " + _toDisplayString(_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.intakeYear), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            (_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.tuitionFeeCurrency)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "ModalConfirmationTitle" }, "Tuition Fee", -1 /* CACHED */)),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.tuitionFee) + " " + _toDisplayString(_ctx.enrolmentReview.selectedTriggerPayload.enrichmentSpecification.tuitionFeeCurrency.isoCode), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _cache[26] || (_cache[26] = _createElementVNode("i", { class: "lnr-info AttentionRequiredIcon" }, null, -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_62, [
                              _createTextVNode(" After the confirmation you will " + _toDisplayString(_ctx.areNoEnrolmentsAlreadyReviewed ? 'update' : 'overwrite') + " ", 1 /* TEXT */),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.grammaticalNumberTextPresenter.amountOfSelectedEnrolmentsDisplayText), 1 /* TEXT */)
                            ])
                          ]),
                          (_ctx.massReviewTransitionsFailed)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_63, " Sorry, we were unable to apply your changes. Please try again. "))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createVNode(_component_EnrolmentReviewPopupButtons, { enrolmentReview: _ctx.enrolmentReview }, null, 8 /* PROPS */, ["enrolmentReview"])
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}